module.exports = __webpack_public_path__ + "static/media/python.8eefa0a8.png";